(function (angular) {
    'use strict';

    angular.module('channels')
        /**
         *
         */
        .controller('channelsConfigurationCtrl', ['$scope', '$location', '$stateParams', 'jwtService', 'emailSettings', 'fbData',
            'customChannelsData', 'whatsAppCloudData', 'whatsAppData', 'smsChannelService', 'messengerChannelService', 'facebookService', 'growlService', 'emailChannelService', 'webchatChannelService',
            'appMessagingChannelService', 'customChannelConfigService', 'customChannelService', 'twitterServices', 'twitterData', 'twitterChannelService',
            'channelsProvider', 'emailSettingsService', 'whatsAppServices', 'whatsAppChannelService', 'sweetAlertService', 'rcsData', 'rcsChannelService', function ($scope, $location, $stateParams, jwtService, emailSettings, fbData, customChannelsData, whatsAppCloudData, whatsAppData,
                smsChannelService, messengerChannelService, facebookService, growlService, emailChannelService, webchatChannelService, appMessagingChannelService,
                customChannelConfigService, customChannelService, twitterServices, twitterData, twitterChannelService, channelsProvider, emailSettingsService, whatsAppServices, whatsAppChannelService, sweetAlertService, rcsData, rcsChannelService) {

                // TODO permissions!

                function getWhatsAppCloudChannelConfig(channel) {
                    return {
                        icon: "ci-whatsapp c-whatsapp-channel-icon",
                        label: channelsProvider.whatsApp.name,
                        subLabel: channel.phoneNumber,
                        id: `whatsAppCloud_${channel.phoneNumberId}`,
                        disabled: false,
                        configured: true,
                        docsLink: 'https://docs.cpaas.dotdigital.com/docs/channel-setup-whatsapp',
                        remove: {
                            delete: true,
                            cb: whatsAppServices.removeWhatsAppCloudConfiguration,
                            params: channel.phoneNumber
                        },
                        configuredBtns: [{
                            label: 'Configuration',
                            cb: whatsAppChannelService.getCloudConfiguration,
                            params: channel
                        }]
                    };
                }

                function getCustomChannelConfig(channel) {
                    return {
                        icon: "ci-custom c-brand-icon",
                        label: channel.name,
                        id: channel.id,
                        configured: true,
                        remove: {
                            delete: true,
                            cb: customChannelService.deleteCustomChannel,
                            params: channel.id
                        },
                        docsLink: 'https://docs.cpaas.dotdigital.com/docs/channel-setup-custom-channels',
                        configuredBtns: [{
                            label: 'Edit',
                            cb: customChannelConfigService.getCustomConfig
                        }, {
                            label: 'Id',
                            cb: customChannelConfigService.getChannelId
                        }]
                    };
                }

                $scope.$on('FB channel configured', function () {

                    $scope.channelsConfig[$scope.channelsConfig.findIndex(function (el) { return el.id == "fbMessenger"; })].configured = true;
                });

                $scope.$on('Email channel configured', function () {

                    $scope.channelsConfig[$scope.channelsConfig.findIndex(function (el) { return el.id == "email"; })].configured = true;
                });

                $scope.$on('Twitter channel configured', function () {
                    $scope.channelsConfig[$scope.channelsConfig.findIndex(function (el) { return el.id == "twitterDm"; })].configured = true;
                });

                $scope.$on('WhatsApp channel created', function (event, data) {
                    let addIndex = $scope.channelsConfig.findIndex(function (el) { return el.id == "whatsAppAdd" });
                    $scope.channelsConfig.splice(addIndex, 0, getWhatsAppCloudChannelConfig(data));
                });

                // On premise
                $scope.$on('WhatsApp channel configured', function (event, phoneNumber) {
                    $scope.channelsConfig[$scope.channelsConfig.findIndex(function (el) { return el.id == "whatsApp" && el.subLabel === phoneNumber; })].configured = true;
                });

                $scope.$on('Custom channel created', function (event, data) {
                    $scope.channelsConfig.splice($scope.channelsConfig.length - 1, 0, getCustomChannelConfig(data));
                });


                if (Object.keys($location.search()).length > 0) {
                    var config = {
                        appId: $location.search().appId,
                        shortLiveToken: $location.search().access_token,
                        accessError: $location.search().error_message
                    };
                    messengerChannelService.getMessengerConfig(config);
                }
                $scope.accountId = jwtService.payload.accountId;
                $scope.userId = jwtService.payload.userId;

                $scope.channelsConfig = [
                    {
                        icon: "ci-sms c-sms-channel-icon",
                        label: channelsProvider.sms.name,
                        id: 'sms',
                        disabled: false,
                        configured: false,
                        docsLink: 'https://docs.cpaas.dotdigital.com/docs/channel-setup-sms',
                        primaryBtns: [
                            {
                                label: 'Numbers',
                                cb: smsChannelService.getNumbersConfig
                            },
                            {
                                label: 'Tracking',
                                cb: smsChannelService.getTrackingConfig
                            }
                        ],
                        configuredBtns: [{
                            label: 'Edit',
                            cb: ''
                        }]
                    },
                    {
                        icon: "ci-messenger c-fb-channel-icon",
                        label: channelsProvider.fbMessenger.name,
                        id: 'fbMessenger',
                        disabled: false,
                        configured: fbData,
                        remove: {
                            cb: facebookService.deleteFacebookConfig
                        },
                        docsLink: 'https://docs.cpaas.dotdigital.com/docs/channel-setup-facebook-messenger',
                        primaryBtns: [{
                            label: 'Set up',
                            cb: messengerChannelService.getMessengerConfig
                        }],
                        configuredBtns: [{
                            label: 'Edit',
                            cb: messengerChannelService.getMessengerConfig
                        }]
                    },
                    {
                        icon: "ci-email c-email-channel-icon",
                        label: channelsProvider.email.name,
                        id: 'email',
                        disabled: false,
                        configured: emailSettings,
                        remove: {
                            cb: emailSettingsService.deleteEmailSettings
                        },
                        docsLink: 'https://docs.cpaas.dotdigital.com/docs/channel-setup-email',
                        disabledCta: {
                            icon: 'lock open',
                            label: 'Upgrade to Toolkit Pro',
                            cb: ''
                        },
                        primaryBtns: [{
                            label: 'Set up',
                            cb: emailChannelService.getEmailConfig
                        }],
                        configuredBtns: [{
                            label: 'Edit',
                            cb: emailChannelService.getEmailConfig
                        }, {
                            label: 'Domains',
                            cb: emailChannelService.showDomains
                        }]
                    },
                    {
                        icon: 'ci-app-messaging c-app-channel-icon',
                        label: channelsProvider.appMessaging.name,
                        id: 'appMessaging',
                        disabled: false,
                        configured: false,
                        docsLink: 'https://docs.cpaas.dotdigital.com/docs/channel-setup-app-messaging',
                        primaryBtns: [
                            {
                                icon: 'android',
                                cb: appMessagingChannelService.getAndroidConfig
                            }, {
                                customIcon: 'ci-apple-logo',
                                cb: appMessagingChannelService.getAppleConfig
                            }, {
                                label: 'Authentication',
                                cb: appMessagingChannelService.getAuthenticationConfig
                            }]
                    },
                    {
                        icon: "ci-web c-web-channel-icon",
                        label: 'Web Chat',
                        id: 'webchat',
                        disabled: false,
                        configured: false,
                        docsLink: 'https://docs.cpaas.dotdigital.com/docs/channel-setup-webchat',
                        primaryBtns: [
                            {
                                label: 'Colours',
                                cb: webchatChannelService.getColorsConfig
                            },
                            {
                                label: 'Theme',
                                cb: webchatChannelService.getThemeConfig
                            },
                            {
                                label: 'Code',
                                cb: webchatChannelService.getCodeConfig
                            }]
                    },
                    {
                        icon: "ci-twitter-dm c-twitter-dm-channel-icon",
                        label: channelsProvider.twitterDm.name,
                        id: 'twitterDm',
                        disabled: false,
                        configured: twitterData,
                        remove: {
                            cb: twitterServices.deleteTwitterDetails
                        },
                        docsLink: 'https://docs.cpaas.dotdigital.com/docs/channel-setup-twitter',
                        primaryBtns: [{
                            label: 'Set up',
                            cb: twitterChannelService.getTwitterConfig
                        }],
                        configuredBtns: [{
                            label: 'Edit',
                            cb: twitterChannelService.getTwitterConfig
                        }]
                    }
                ];
                //we can have multiple whatsApp configurations so we have to add it one by one
                getConfiguredWhatsAppCloud();
                getConfiguredWhatsApp();

                getConfiguredRcs();

                function getConfiguredRcs() {
                    for (var singleRcsData of rcsData) {
                        var rcsConfig = {
                            icon: "ci-rcs c-rcs-channel-icon",
                            label: channelsProvider.rcs.name,
                            subLabel: singleRcsData.agentName,
                            nextSubLabel: singleRcsData.isDefault,
                            agentId: singleRcsData.agentId,
                            id: 'rcs',
                            disabled: false,
                            configured: (singleRcsData.status === "ready" || singleRcsData.status === "launched"),
                            //TODO: change link for docs
                            docsLink: 'https://docs.cpaas.dotdigital.com/docs/channel-setup-rcs',
                            primaryBtns: [{
                                label: 'Details',
                                cb: rcsChannelService.getRcsConfig,
                                params: singleRcsData
                            }],
                            configuredBtns: [{
                                label: 'Testers',
                                cb: rcsChannelService.getTesters,
                                params: singleRcsData
                            },
                            {
                                label: 'Details',
                                cb: rcsChannelService.getRcsConfig,
                                params: singleRcsData
                            }],
                        }
                        $scope.channelsConfig.push(rcsConfig);
                    }
                };

                $scope.$on('defaultAgentSet', refreshRcs);

                function refreshRcs($event, agentId) {
                    for (var singleConfig of $scope.channelsConfig) {
                        if (singleConfig.id === 'rcs') {
                            if (singleConfig.agentId === agentId) {
                                singleConfig.nextSubLabel = true;
                            }
                            else {
                                singleConfig.nextSubLabel = false;
                            }
                        }
                    }
                }

                function getConfiguredWhatsAppCloud() {
                    for (var singleWhatsAppData of whatsAppCloudData) {
                        $scope.channelsConfig.push(getWhatsAppCloudChannelConfig(singleWhatsAppData));
                    }

                    $scope.channelsConfig.push({
                        icon: "ci-whatsapp c-whatsapp-channel-icon",
                        label: channelsProvider.whatsApp.name,
                        id: "whatsAppAdd",
                        disabled: false,
                        configured: false,
                        docsLink: 'https://docs.cpaas.dotdigital.com/docs/channel-setup-whatsapp',
                        primaryBtns: [{
                            label: 'Add WhatsApp integration',
                            width: 'w-100',
                            cb: whatsAppChannelService.launchWhatsAppSignupForm
                        }]
                    });
                }

                function getConfiguredWhatsApp() {
                    for (var singleWhatsAppData of whatsAppData) {
                        var whatsAppConfig = {
                            icon: "ci-whatsapp c-whatsapp-channel-icon",
                            label: channelsProvider.whatsApp.name,
                            subLabel: singleWhatsAppData.phoneNumber,
                            id: 'whatsApp',
                            disabled: false,
                            configured: singleWhatsAppData.verificationStatus === "completed",
                            docsLink: 'https://docs.cpaas.dotdigital.com/docs/channel-setup-whatsapp',
                            primaryBtns: [{
                                label: 'Verify',
                                cb: whatsAppChannelService.verifyPhone,
                                params: singleWhatsAppData
                            }, {
                                label: 'Templates',
                                cb: whatsAppChannelService.getHsms,
                                params: singleWhatsAppData
                            }],
                            configuredBtns: [{
                                label: 'Business Profile',
                                cb: whatsAppChannelService.getBusinessProfileConfig,
                                params: singleWhatsAppData
                            }, {
                                label: 'Templates',
                                cb: whatsAppChannelService.getHsms,
                                params: singleWhatsAppData
                            }]
                        }
                        $scope.channelsConfig.push(whatsAppConfig);
                    }
                }

                addCustomChannelsToConfig();

                function addCustomChannelsToConfig() {
                    var channelConfig;
                    if (customChannelsData && customChannelsData.length > 0) {
                        customChannelsData.forEach(function (channel) {
                            $scope.channelsConfig.push(getCustomChannelConfig(channel));
                        });
                    }

                    channelConfig = {
                        icon: "ci-custom c-brand-icon",
                        label: 'Custom Channel',
                        id: 'customAdd',
                        disabled: false,
                        configured: false,
                        docsLink: 'https://docs.cpaas.dotdigital.com/docs/channel-setup-custom-channels',
                        primaryBtns: [{
                            label: 'Add new channel',
                            width: 'w-100',
                            cb: customChannelConfigService.getCustomConfig
                        }]
                    };
                    $scope.channelsConfig.push(channelConfig);
                }

                $scope.removeChannel = function (channel) {
                    return sweetAlertService.confirmationAlert(
                        "Are you sure?",
                        `Are you sure you want to remove the ${channel.label} channel?`,
                        "Yes, remove it!",
                        "No",
                        function (isConfirm) {
                            if (!isConfirm)
                                return;

                            channel.remove.cb($stateParams.pickedApiSpaceId, channel.remove.params)
                                .then(function () {
                                    growlService.success(`The ${channel.label} channel was deleted`);
                                    if (channel.remove.delete) {
                                        _.remove($scope.channelsConfig, function (c) {
                                            return c.id === channel.id;
                                        });
                                    }
                                    else {
                                        $scope.channelsConfig[$scope.channelsConfig.findIndex(function (el) { return el.id === channel.id; })].configured = false;
                                    }
                                }).catch(function (error) {
                                    growlService.danger(`Could not delete the ${channel.label} channel due to: ${error.statusText}`);
                                });
                        }
                    );
                }
            }]);
})(window.angular);